import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { CustomConfirmAlert as confirmAlert } from '../../custom-confirm-alert';
import { useTranslation } from 'react-i18next';


const ActionsRenderer = forwardRef((props, ref) => {


    const [disabled, setDisabled] = useState(false);
    const { t } = useTranslation();

    var cellRendererParams=props.colDef.cellRendererParams;

    const handleDeleteClicked = (e) => {
        e.preventDefault();

        confirmAlert({
            title: t("submitConfirm"),
            message: t("areYouSure"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        if (cellRendererParams.deleteRow) {
                            cellRendererParams.deleteRow(props);
                        } else if (cellRendererParams.deleteRowById) {
                            cellRendererParams.deleteRowById(props.rowIndex, props.api);
                        }
                    }
                },
                {
                    label: t('No'),
                    onClick: () => {
                    }
                }
            ]
        });
    }
    const handleEditClicked = (e) => {
        e.preventDefault();
        cellRendererParams.hangleEdit(props)
    }
    
    // Support for modal-based edit (e.g., sale entries extra modal)
    const handleShowExtraClicked = (e) => {
        e.preventDefault();
        if (cellRendererParams.onShowExtra) {
            cellRendererParams.onShowExtra(props.rowIndex, props.node.data);
        }
    }
    
    // Support for removing row (e.g., sale entries)
    const handleRemoveRowClicked = (e) => {
        e.preventDefault();
        confirmAlert({
            title: t("submitConfirm"),
            message: t("areYouSure"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        if (cellRendererParams.onRemoveRow) {
                            props.api.applyTransaction({ remove: [props.node.data] });
                            cellRendererParams.onRemoveRow();
                        }
                    }
                },
                {
                    label: t('No'),
                    onClick: () => {}
                }
            ]
        });
    }
    
    useImperativeHandle(ref, () => {
        var countDisplayedRows = props.api.getDisplayedRowCount() - 1;
        if (props.rowIndex == countDisplayedRows) {
            setDisabled(true);
        }
        else {
            setDisabled(false);
        }
        return {
            refresh(params) {

            }
        };
    });

    if(cellRendererParams.action=="edit"){
        return <span><button onClick={handleEditClicked} className="btn btn-sm btn-warning"><i className="fa fa-edit"></i></button></span>
    }
    else if(cellRendererParams.action=="delete"){
        return <span><button onClick={handleDeleteClicked} disabled={disabled} className="btn btn-sm btn-danger circle-btn"><i className="fa fa-times"></i></button></span>;
    }
    else if(cellRendererParams.action=="edit_delete"){
        return  <> 
            <span><button onClick={handleEditClicked}   disabled={disabled} className="btn btn-sm btn-warning circle-btn"><i className="fa fa-edit"></i></button></span>
            <span><button onClick={handleDeleteClicked} disabled={disabled} className="btn btn-sm btn-danger circle-btn"><i className="fa fa-times"></i></button></span>
        </>
    }
    // New action type for sale entries: edit via modal + delete
    else if(cellRendererParams.action=="edit_modal_delete"){
        return  <> 
            <span><button onClick={handleShowExtraClicked} disabled={disabled} className="btn btn-sm btn-skin action action-edit"><i className="fa fa-pencil"></i></button></span>
            <span><button onClick={handleRemoveRowClicked} disabled={disabled} className="btn btn-sm btn-skin action action-remove"><i className="fa fa-times-circle"></i></button></span>
        </>
    }
    else{
        return <span><button onClick={handleDeleteClicked} disabled={disabled} className="btn btn-sm btn-danger circle-btn"><i className="fa fa-times"></i></button></span>;
    }
});

export default ActionsRenderer